// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2UDQO","sendOtp":"AuthorizeToLogin_sendOtp__3J6nv"};